module.exports = __webpack_public_path__ + "img/aritzia.fe75c2e.svg";